/* ============================================================================
   RETOUR CLIENT 2026-09-22 — RETIRER LE TÉLÉCHARGEMENT DES VIDÉOS
   ----------------------------------------------------------------------------
   Le lecteur natif de Chrome propose « Download » dans son menu, et le clic
   droit propose « Enregistrer la vidéo sous… ». On ferme ces deux portes sur
   TOUTES les vidéos du site : médias produit, carrousel UGC, avis clients
   (l'app d'avis injecte les siennes après coup, d'où l'observateur).

   ⚠️ CE N'EST PAS UNE PROTECTION. Le fichier reste servi en clair par le CDN
   Shopify : n'importe qui sachant ouvrir l'onglet « Réseau » de son navigateur
   peut toujours le récupérer. C'est un garde-barrière contre le geste facile,
   pas un verrou. Un vrai verrou demanderait un hébergement vidéo à URL signée
   (Cloudflare Stream, Vimeo…), ce que les fichiers Shopify ne font pas.
   ============================================================================ */
(function () {
  'use strict';

  function durcir(v) {
    if (!v || v.__refonteNoDl) return;
    v.__refonteNoDl = true;
    // retire l'entrée « Download » du menu du lecteur natif
    var liste = v.getAttribute('controlsList') || '';
    if (liste.indexOf('nodownload') === -1) {
      v.setAttribute('controlsList', (liste + ' nodownload').trim());
    }
    // ferme « Enregistrer la vidéo sous… » du clic droit, sur la vidéo seule
    v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  function balayer(racine) {
    if (!racine || !racine.querySelectorAll) return;
    if (racine.tagName === 'VIDEO') durcir(racine);
    racine.querySelectorAll('video').forEach(durcir);
  }

  balayer(document);

  // les carrousels, la visionneuse d'avis et les sections rechargées en AJAX
  // ajoutent leurs vidéos après coup.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) balayer(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
